import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ParentService } from '../_services/parent.service';
import { StudentService } from '../_services/student.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { Subject, Subscription, distinctUntilChanged, forkJoin, takeUntil, tap, combineLatest, debounceTime } from 'rxjs';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { Sorting } from '../_model/sorting.model';
import { GlobalService } from 'src/app/_services/global.service';
import { Filter } from '../_model/filter.model';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { RequestsService } from '../_services/requests.service';
import { ControlActivationService } from 'src/app/_services/control-activation.service';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { TranslateService } from '@ngx-translate/core';
import { AnnouncementService } from '../_services/announcement.service';
import { element } from 'protractor';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { ModalService } from 'src/app/shared/modal/modal.service';
import { ClassStudentsService } from 'src/app/school-management/_services/class-students.service';
import { StaffService } from 'src/app/school-management/_services/staff.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';

declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListingComponent implements OnInit, OnDestroy {
  filterStatus = false;
  students = [];
  parents = [];
  helpers = [];
  staff = [];
  requests = [];
  searchText: string;
  filterValues: Filter;
  listType: string;
  compactView: boolean;
  noResultsFlag: boolean = false;
  rowsNumberToBeShowed: number;
  rowsSubscription;
  resetSubscription;
  searchSubscription;
  filterSubscription;
  AllRowsIsChecked: boolean;
  selectedCheckBoxes = [];
  from: number;
  to: number;
  total: number;
  nextPage: number;
  prevPage: number;
  currentPage: number;
  lastPage: number;
  sorting: Sorting;
  loading: boolean;
  request_number: number;
  editFlags = [];
  grades: any = [];
  alertData: any;
  currLang;
  tableControls: any = { data: [] };
  rowsView: string = '';
  requestType:string;
  requestCardData = null;
  earlyDismissalRequestCardData = null;
  // early dismissal filters + cursor pagination
  earlyDismissalType: 'today' | 'schedule' | null = null;
  earlyDismissalStatus: 'pending' | 'approved' | 'declined' | 'cancelled' | null = null;
  earlyDismissalCursor: string | null = null;
  earlyDismissalLoading: boolean = false;
  earlyDismissalInitialized: boolean = false;
  destroy$ = new Subject<void>();
  showSuccessPasswordResetModal: boolean = false;
  @ViewChild('modalContainer', { read: ViewContainerRef }) modalContainer!: ViewContainerRef;

  constructor(
    private globalService: GlobalService,
    private qrControl: ControlQrService,
    private controlActivation: ControlActivationService,
    private messageControl: MessagesControlService,
    private controlDeletion: ControlDeletionService,
    private dataService: DataService,
    private studentService: StudentService,
    private router: Router,
    private translate: TranslateService,
    private parentService: ParentService,
    private announcementService: AnnouncementService,
    private requestsService: RequestsService,
    private modalService: ModalService,
    private classStudentsService: ClassStudentsService,
    private staffService: StaffService,
    private errorMsgService: ErrorMsgService) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)listing_(f)getLang_(L)82' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.rowsSubscription = new Subscription();
    this.resetSubscription = new Subscription();
    this.searchSubscription = new Subscription();
    this.filterSubscription = new Subscription();




    let reloadFlag = localStorage.getItem("relaod");
    if (reloadFlag == 'true') {
      localStorage.setItem("relaod", 'false');
      window.location.reload();
    }
  }

  ngOnDestroy(): void {
    this.rowsSubscription.unsubscribe();
    this.resetSubscription.unsubscribe();
    this.searchSubscription.unsubscribe();
    this.filterSubscription.unsubscribe();
    this.dataService.toggleFilterStatus(false);
  }

  ngOnInit() {
    this.announcementService.getUserAlerts().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)listing_(f)getUserAlerts_(L)111' , res);
      this.alertData = res['data'];
      if (res['data'].length != 0) {
        $('#announcementModal').modal("show");
      }
    })
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)listing_(f)getLang_(L)118' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.globalService.startLoading();
    this.dataService.setFilterValue(new Filter());
    this.request_number = 0;
    this.controlDeletion.toggleDeleteBtn(false);
    this.messageControl.toggleMessageBtn(false);
    this.currentPage = 1;
    this.sorting = {
      name: 'asc',
      grade: null,
      class: null
    }
    this.filterValues = new Filter();
    this.filterValues.grades = [];
    this.filterValues.classes = [];

    this.globalService.getLoading().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)listing_(f)getLoading_(L)138' , res);
      this.loading = res;
    })

    this.dataService.getFilterStatus().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)listing_(f)getFilterStatus_(L)143' , res);
      this.filterStatus = res;
    })

    this.controlActivation.getToggleUserBtn().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)listing_(f)getToggleUserBtn_(L)148' , res);
      if (Object.keys(res).length > 0) {
        res.source.checked = !res.checked;
      }
    })

    this.dataService.getRowsStyle().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      // this.compactView = res;
      this.rowsView = res ? "compact" : "list";
      this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
        //console.log('(c)listing_(f)translatInit_(L)158' , res);
        this.setTableData();
      });
      this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
        //console.log('(c)listing_(f)translateOnChange_(L)162' , res);
        this.setTableData();
      });
    })

    let r = this.controlDeletion.getResetSelectedRows().subscribe(res => {
      this.selectedCheckBoxes = res === true ? [] : this.selectedCheckBoxes;
    })
    this.resetSubscription.add(r);

    let s = this.dataService.getRowsNumberShown().subscribe(res => {
      // the user changed the rows number not editing
      if (this.rowsNumberToBeShowed !== res) {
        this.currentPage = 1;
      }
      // selection is kept across pages / filters, so a smaller page size must not truncate it
      this.rowsNumberToBeShowed = res;
      this.AllRowsIsChecked = false;
      // this.dataService.setSearchText(null);
      // this.controlDeletion.toggleDeleteBtn(false);
      // this.messageControl.toggleMessageBtn(false);
      this.showList();
    })
    this.rowsSubscription.add(s);

    let x = this.dataService.getSearchText().subscribe(res => {
      if (res !== null) {
        // selection is intentionally kept so users can build a selection across searches
        this.searchText = res;
        this.currentPage = 1;
        this.AllRowsIsChecked = false;
        this.syncSelectionButtons();
        this.showList(true);
      }
    })
    this.searchSubscription.add(x);

    let f = this.dataService.getFilterValue().subscribe((res: any) => {      
      this.currentPage = 1;
      this.filterValues = res;
      this.AllRowsIsChecked = false;
      // selection is intentionally kept so users can build a selection across filters
      this.syncSelectionButtons();
      if (Object.keys(this.filterValues).length !== 0) {
        this.showList();
      }
    })
    this.filterSubscription.add(f);

    // early dismissal filters: coalesce type/status changes and fetch once
    combineLatest([
      this.dataService.getEarlyDismissalTypeFilter(),
      this.dataService.getEarlyDismissalStatusFilter()
    ])
    .pipe(debounceTime(0), takeUntil(this.destroy$))
    .subscribe(([type, status]) => {
      this.earlyDismissalType = (type as any) as 'today' | 'schedule' | null;
      this.earlyDismissalStatus = (status as any) as 'pending' | 'approved' | 'declined' | 'cancelled' | null;
      if (this.listType === 'early-dismissal-requests') {
        this.earlyDismissalCursor = null;
        this.getEarlyDismissalRequests(true);
      }
    });

    this.dataService.getGrades().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)listing_(f)getGrades_(L)217' , res);
      this.grades = res;
    });

    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  showList(resetFlag:boolean = false) {
    this.globalService.startLoading();
    this.request_number = this.request_number + 1;
    this.listType = window.location.pathname.split('/')[2];
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res.url) {
        this.listType = res.url.split('/')[2];
      }
    })
    switch (this.listType) {
      case 'students':
          this.getStudents();
          this.getPendingRequests();
          this.getEditRequests();
          this.getEarlyDismissalRequests();
        break;
      case 'parents':
          this.getParents();
        break;
      case 'assistants':
          this.getHelpers();
        break;
      case 'pending-requests':
        this.requestType = 'pending'
        this.getPendingRequests();
        break;

        case 'edit-requests':
          this.requestType = 'edit'
          this.getEditRequests();   
        break;

        case 'early-dismissal-requests':
          this.requestType = 'early-dismissal'
          // Ensure defaults are present when entering the tab; avoid overriding if already set
          let pushedDefault = false;
          if (!this.earlyDismissalType) {
            this.dataService.setEarlyDismissalTypeFilter('today');
            pushedDefault = true;
          }
          if (!this.earlyDismissalStatus) {
            this.dataService.setEarlyDismissalStatusFilter('pending');
            pushedDefault = true;
          }
          if (!pushedDefault) {
            this.earlyDismissalCursor = null;
            this.getEarlyDismissalRequests(resetFlag);
          }
        break;

    }
  }

  getStudents(){
    this.studentService.getStudents(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number)
    .pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)listing_(f)getStudents_(L)236' , res);
      if (this.request_number == res.request_number) {
        let dataArray: any = [];

        dataArray = res['data'].map(element => (
          {
            student_image: element.image_path,
            name: element.name,
            grade: element.class?.grade.name,
            class: element.class?.name,
            national_id: element.national_id,
            id: element.id,
            users: element.users,
            parents: element.users?.filter(u => u.pivot?.type === 'father' || u.pivot?.type === 'mother') || [],
            parent_names: element.parent_names || [],
            is_verified_student: element.is_verified_student || false,
            qr_code: element.qr_code,
            type:'student',
            student_can_self_checkout: element.student_can_self_checkout ? true : false
          }
        ))
        // res['data'].forEach(element => {
        //   dataArray.push({
        //     student_image: element.image_path,
        //     name: element.name,
        //     grade: element.class?.grade.name,
        //     class: element.class?.name,
        //     national_id:element.national_id,
        //     id:element.id,
        //     users:element.users
        //   })
        // });
        this.students = dataArray;
        this.from = res.from;
        this.to = res.to;
        this.total = res.total;
        this.lastPage = res.last_page;
        this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
          //console.log('(c)listing_(f)translateInit_(L)270' , res);
          this.setTableData();
        });
        // this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
        //   this.setTableData();
        // });
        this.translate.onLangChange.pipe(
          distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
          tap((res) => {
            //console.log('(c)listing_(f)translateOnChange_(L)280' , res);
            this.setTableData();
          }),
          takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
        )
        .subscribe();
        if (this.selectedCheckBoxes.length === 0) {
          this.students.map(student => {
            student['isSelected'] = false;
          })
        }
        else {
          this.selectedCheckBoxes.map(selectedCB => {
            let studentIndex = this.students.findIndex(student => selectedCB.id === student.id);
            if (studentIndex !== -1) {
              this.students[studentIndex].isSelected = true;
            }
          })
          if (this.students.length > 0 && this.students.every(student => student.isSelected === true)) {
            this.AllRowsIsChecked = true;
          }
          else {
            this.AllRowsIsChecked = false;
          }
        }
        this.globalService.stopLoading();
      }
    })
  }

  getParents(){
    this.parentService.getParents(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)listing_(f)getParents_(L)305' , res);
      if (this.request_number == res.request_number) {
        res.data.forEach(parent => {
          parent.type = 'parent'
        });
        this.parents = res.data;
        this.from = res.from;
        this.to = res.to;
        this.total = res.total;
        this.lastPage = res.last_page;
        this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
          //console.log('(c)listing_(f)translateInit_(L)316' , res);
          this.setTableData();
        });
        // this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
        //   this.setTableData();
        // });
        this.translate.onLangChange.pipe(
          distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
          tap((res) => {
            //console.log('(c)listing_(f)translateOnChange_(L)335' , res);
            this.setTableData();
          }),
          takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
        )
        .subscribe();
        if (this.selectedCheckBoxes.length === 0) {
          this.parents.map(parent => {
            parent['isSelected'] = false;
          })
        }
        else {
          this.selectedCheckBoxes.map(selectedCB => {
            let parentIndex = this.parents.findIndex(parent => selectedCB.id === parent.id);
            if (parentIndex !== -1) {
              this.parents[parentIndex].isSelected = true;
            }
          })

          if (this.parents.every(parent => parent.isSelected === true)) {
            this.AllRowsIsChecked = true;
          }
          else {
            this.AllRowsIsChecked = false;
          }
        }
        this.globalService.stopLoading();
      }
    })
  }

  getHelpers(){
    this.parentService.getHelpers(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      console.log('helpers' , res);
      if (this.request_number == res.request_number) {
        res.data.forEach(helper => {
          helper.type = 'helper'
        });
        this.helpers = res.data;
        this.from = res.from;
        this.to = res.to;
        this.total = res.total;
        this.lastPage = res.last_page;
        this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.setTableData();
        });
        this.translate.onLangChange.pipe(
          distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
          tap((res) => {
            this.setTableData();
          }),
          takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
        )
        .subscribe();
        if (this.selectedCheckBoxes.length === 0) {
          this.helpers.map(helper => {
            helper['isSelected'] = false;
          })
        }
        else {
          this.selectedCheckBoxes.map(selectedCB => {
            let helperIndex = this.helpers.findIndex(helper => selectedCB.id === helper.id);
            if (helperIndex !== -1) {
              this.helpers[helperIndex].isSelected = true;
            }
          })

          if (this.helpers.every(helper => helper.isSelected === true)) {
            this.AllRowsIsChecked = true;
          }
          else {
            this.AllRowsIsChecked = false;
          }
        }
        this.globalService.stopLoading();
      }
    })
  }

  getPendingRequests(){
    forkJoin([this.requestsService.getRequests(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number),
    ]).pipe(takeUntil(this.destroy$)).subscribe(results => {
      //console.log('(c)listing_(f)getPendingRequests_(L)368' , results);
      // if (this.request_number == res.request_number) {
      this.total = results[0]["total"];
      // to handle dublicates when requests are in the first page < 25 request 
      if (this.total <= 25) {
        this.requests = [...results[0]["data"]];
      }
      else {
        this.requests = [...this.requests, ...results[0]["data"]];
      }
      this.from = results[0]["from"];
      this.to = results[0]["to"];
      this.lastPage = results[0]["last_page"];
      this.grades = this.dataService.allGrades;
      this.dataService.setRequestsCounter(this.total);
      this.globalService.stopLoading();
    })
  }

  getEditRequests(){
    forkJoin([this.requestsService.getEditRequests(this.rowsNumberToBeShowed, this.currentPage),
    ]).pipe(takeUntil(this.destroy$)).subscribe(results => {
      //console.log('(c)listing_(f)getEditRequests_(L)390' , results);
      // if (this.request_number == res.request_number) {
      this.total = results[0]["total"];
      // to handle dublicates when requests are in the first page < 25 request 
      if (this.total <= 25) {
        this.requests = [...results[0]["data"]];
      }
      else {
        this.requests = [...this.requests, ...results[0]["data"]];
      }
      this.from = results[0]["from"];
      this.to = results[0]["to"];
      this.lastPage = results[0]["last_page"];
      this.dataService.setEditRequestsCounter(this.total);
      this.globalService.stopLoading();
    })
  }

  getEarlyDismissalRequests(resetFlag: boolean = false){
    if (this.earlyDismissalLoading) { return; }
    if (resetFlag) {
      this.requests = [];
    }
    this.earlyDismissalLoading = true;
    this.globalService.startLoading();
    forkJoin([
      this.requestsService.getEarlyDismissalRequests(
        this.rowsNumberToBeShowed,
        this.currentPage,
        this.searchText,
        this.earlyDismissalType ?? 'today',
        this.earlyDismissalStatus ?? 'pending',
        this.earlyDismissalCursor
      ),
    ]).pipe(takeUntil(this.destroy$)).subscribe((results:any) => {
      const res = results[0];
      this.total = res?.meta?.total ?? 0;
      const newData = res?.data ?? [];
      // dedupe by id
      const existingIds = new Set(this.requests.map((r: any) => r.id));
      const uniqueNew = newData.filter((r: any) => !existingIds.has(r.id));
      this.requests = [...this.requests, ...uniqueNew];
      // update cursor
      this.earlyDismissalCursor = res?.meta?.has_next ? res?.meta?.next_page: null;
      this.dataService.setEarlyDismissalRequestsCounter(this.total);
      this.dataService.setEarlyDismissalDisplayedCount(this.requests.length);
      this.globalService.stopLoading();
      this.earlyDismissalLoading = false;
    }, _ => {
      this.globalService.stopLoading();
      this.earlyDismissalLoading = false;
    })
  }

  tackActionFromCard(event) {
    this.requests = this.requests.filter(request => request.id != event.id);
    switch (this.listType) {
      case 'pending-requests':
        this.dataService.setRequestsCounter(this.requests.length);
        break;
        case 'edit-requests':
          this.dataService.setEditRequestsCounter(this.requests.length);
        break;
        case 'early-dismissal':
          this.dataService.setEarlyDismissalRequestsCounter(this.requests.length);
        break;
    }
    if (event.action == "reload" && this.requests.length < 10) {
      this.showList();
    }
  }

  getImage(imagePath: string) {
    return environment.img_url + imagePath;
  }

  changeActivation(event, parent) {
    let body = { 'noOfShownRows': this.rowsNumberToBeShowed, 'type': this.listType, 'userName': parent.name, 'userId': parent.id, 'state': event.checked, 'event': event }
    this.controlActivation.setToggledUSer(body);
    $("#confirmModal").modal("show");
  }

  nextBtnHandler() {
    if (this.listType === 'early-dismissal-requests') {
      if (this.earlyDismissalCursor) {
        this.getEarlyDismissalRequests();
      }
      return;
    }
    if (this.currentPage < this.lastPage) {
      this.currentPage = this.currentPage + 1;
      this.showList();
    }
  }

  paginationHandling(event) {
    if (this.listType === 'early-dismissal-requests') {
      if (event.dir > 0 && this.earlyDismissalCursor) {
        this.getEarlyDismissalRequests();
      }
      return;
    }
    this.currentPage += event.dir;
    this.showList();
  }
  toggleSorting(sortingBy: string) {
    let previousValuesOfSorting = this.sorting;
    this.sorting = {
      name: null,
      grade: null,
      class: null
    }
    this.sorting[sortingBy] = previousValuesOfSorting[sortingBy] === 'asc' ? 'desc' : 'asc';
    this.showList();
  }

  viewStudent(student) {
    this.studentService.getStudentById(student.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)listing_(f)viewStudent_(L)482' , res);
      this.openModal('add-student' , 'view' , res)
      // this.studentService.setStudentData(res, 'view');
      // $("#addStudentModal").modal("show");
      // this.scrollContentTop('#addStudentModal');
    })
  }

  editStudent(e, student) {
    e.stopPropagation();
    this.studentService.getStudentById(student.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)listing_(f)editStudent_(L)492' , res);
      this.openModal('add-student' , 'edit' , res)
      // this.studentService.setStudentData(res, 'edit');
      // $("#addStudentModal").modal("show");
      // this.scrollContentTop('#addStudentModal');
    })
  }

  addStudent(){
    this.openModal('add-student','add', null)
    // $("#addStudentModal").modal("show");
    // this.scrollContentTop("#addStudentModal");
  }

  viewParent(parent) {
    this.parentService.getUserById(parent.id, 'parent').pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)listing_(f)viewParent_(L)506' , res);
      this.openModal('add-parent' , 'view' , res)
      // this.parentService.setParentData(res, 'view');
      // $("#addParentModal").modal("show");
      // this.scrollContentTop('#addParentModal');
    })
  }

  viewAssistant(assistant) {
    this.parentService.getUserById(assistant.id, 'helper').pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.openModal('add-assistant' , 'view' , res)
    })
  }

  assignAssistant(e, selected_student_from_table) {
    e.stopPropagation();
    this.openModal('assign-assistant' , 'add' , selected_student_from_table)
  }

  editParent(e, parent) {
    e.stopPropagation();
    this.parentService.getUserById(parent.id, 'parent').pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)listing_(f)editParent_(L)506' , res);
      this.openModal('add-parent' , 'edit' , res)
      // this.parentService.setParentData(res, 'edit');
      // $("#addParentModal").modal("show");
      // this.scrollContentTop('#addParentModal');
    })
  }

  showQR(e, user) {    
    e.stopPropagation();
    switch (user.type) {
      case 'parent':
        this.qrControl.setParentData(user, 'single');
        $('#qrModal').modal("show");
        break;
        case 'helper':
          this.qrControl.setParentData(user, 'single');
          $('#qrModal').modal("show");
          break;
        case 'student':
          this.qrControl.setStudentData(user, 'single');
          $('#qrStudentModal').modal("show")
          break;
      default:
        break;
    }   
  }

  // to fix cashed scroll after opening and closing of modal for the same user (view , edit)
  scrollContentTop(modalName) {
    $(`${modalName} .modal-body`)[0].scrollTop = 0;
  }

  setTableData() {
    switch (this.listType) {
      case "students":
        this.tableControls = {
          selection: true,
          paging: true,
          view: this.rowsView,
          title:'table-view.titles.students',
          selectedTitle:'table-view.selected-titles.students',
          totalTitle:'table-view.total-titles.students',
          pagination: {
            from: this.from,
            to: this.to,
            total: this.total
          },
          columns: [
            {
              name: "",
              sort: false,
              type: "image",
              source: "student_image"
            },
            {
              name: this.translate.instant('user-management.students.student-name'),
              sort: true,
              type: "string",
              source: "name"
            },
            {
              name: this.translate.instant('user-management.students.national-id'),
              sort: false,
              type: "string",
              source: "national_id",
              copyable: true
            },
            {
              name: this.translate.instant('user-management.students.parents-name'),
              sort: false,
              type: "assigned-parents",
            },
            {
              name: this.translate.instant('user-management.students.grade'),
              sort: true,
              type: "string",
              source: "grade"
            },
            {
              name: this.translate.instant('user-management.students.class'),
              sort: true,
              type: "string",
              source: "class"
            },
            {
              name: this.translate.instant('table-view.quick-actions'),
              sort: false,
              type: "quick-actions-students",
            },
          ],
          data: this.students
        }
        break;
      case "parents":
        this.tableControls = {
          selection: true,
          paging: true,
          view: this.rowsView,
          title:'table-view.titles.parents',
          selectedTitle:'table-view.selected-titles.parents',
          totalTitle:'table-view.total-titles.parents',
          pagination: {
            from: this.from,
            to: this.to,
            total: this.total
          },
          columns: [
            {
              name: "",
              sort: false,
              type: "image",
              source: "image_path"
            },
            {
              name: this.translate.instant('user-management.parents.parent-name'),
              sort: true,
              type: "string",
              source: "name"
            },
            {
              name: this.translate.instant('user-management.parents.national-id'),
              sort: false,
              type: "string",
              source: "national_id",
              copyable: true
            },
            {
              name: this.translate.instant('user-management.parents.phone-number'),
              sort: false,
              type: "string",
              source: "phone_number",
              copyable: true
            },
            {
              name: this.translate.instant('user-management.parents.students-name'),
              sort: false,
              type: "assigned-students",
            },
            {
              name: this.translate.instant('user-management.parents.last-login'),
              sort: false,
              type: "localized-text",
              source: "last_login"
            },
            {
              name: this.translate.instant('table-view.quick-actions'),
              sort: false,
              type: "quick-actions-parents",
            },
          ],
          data: this.parents
        }
        break;

        case "assistants":
          this.tableControls = {
            selection: true,
            paging: true,
            view: this.rowsView,
            title:'table-view.titles.helpers',
            selectedTitle:'table-view.selected-titles.helpers',
            totalTitle:'table-view.total-titles.helpers',
            pagination: {
              from: this.from,
              to: this.to,
              total: this.total
            },
            columns: [
              {
                name: "",
                sort: false,
                type: "image",
                source: "image_path"
              },
              {
                name: this.translate.instant('user-management.helpers.helper-name'),
                sort: true,
                type: "string",
                source: "name"
              },
              {
                name: this.translate.instant('user-management.helpers.national-id'),
                sort: false,
                type: "string",
                source: "national_id"
              },
              // {
              //   name: this.translate.instant('user-management.helpers.activate'),
              //   sort: false,
              //   type: "activate",
              // },
              {
                name: this.translate.instant('user-management.helpers.qr'),
                sort: false,
                type: "qr-code",
              },
              {
                name: this.translate.instant('user-management.control-bar.regenerate-Qr'),
                type: "regenerate-qr",
              },
            ],
            data: this.helpers
          }
          break;
    }
  }

  tableEventHandeler(event) {
    console.log(event);
    switch (event.action) {
      case "rowClicked":
        switch (this.listType) {
          case "students":
            this.viewStudent(event.target.data);
            break;
          case "parents":
            this.viewParent(event.target.data);
            break;
          case "assistants":
              this.viewAssistant(event.target.data);
            break;
        }
        break;
      case "iconClicked":
        switch (this.listType) {
          case "students":
            this.editStudent(event.e, event.target.data);
            break;
          case "parents":
            this.editParent(event.e, event.target.data);
            break;
        }
        break;
      case "checkboxChanged":
        this.selectChanged(event.target);
        break;
      case "clearSelection":
        this.selectedCheckBoxes = [];
        this.syncSelectionButtons();
        break;
      case "activationChanged":
        this.changeActivation(event.e, event.target.data);
        break;
      case "sorting":
        this.toggleSorting(event.target.source);
        break;
      case "pagination":
        this.paginationHandling(event.target);
        break;
      case "showQr":
        this.showQR(event.e, event.target.data);
        break;
      case "AddAssistantClicked":
        this.assignAssistant(event.e, event.target.data);
        break;
      case "scroll":
        break;
      // Student Quick Actions
      case "add-parent":
        this.addParentToStudent(event.e, event.target.data);
        break;
      case "add-assistant":
        this.assignAssistant(event.e, event.target.data);
        break;
      case "edit-student":
        this.editStudent(event.e, event.target.data);
        break;
      case "view-edit-guardians":
        this.viewEditGuardians(event.e, event.target.data);
        break;
      case "toggle-self-checkout":
        this.toggleSelfCheckout(event.target.data, event.target.index);
        break;
      case "view-student-qr":
        this.showQR(event.e, event.target.data);
        break;
      // Parent Quick Actions
      case "edit-parent":
        this.editParent(event.e, event.target.data);
        break;
      case "reset-parent-password":
        this.resetParentPassword(event.e, event.target.data);
        break;
      case "view-parent-qr":
        this.showQR(event.e, event.target.data);
        break;
      case "regenerate-parent-qr":
        this.regenerateParentQr(event.e, event.target.data);
        break;
    }
  }

  // the student is already known here, so the flow opens on its second step
  addParentToStudent(e, student) {
    e.stopPropagation();
    this.openModal('create-parent', 'add', { student: student });
  }

  viewEditGuardians(e, student) {
    e.stopPropagation();
    this.studentService.getStudentById(student.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.openModal('add-student', 'edit', res);
    });
  }

  toggleSelfCheckout(student, index) {
    this.loading = true;
    const newValue = !student.student_can_self_checkout;
    this.students[index].student_can_self_checkout = newValue;

    const body = {
      students: [{ id: student.id, student_can_self_checkout: newValue }]
    };

    this.classStudentsService.saveStudentsSelfcheckout(body).pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        // Success - value already updated optimistically
        this.loading = false;
      },
      err => {
        // Revert on error
        this.students[index].student_can_self_checkout = !newValue;
        this.loading = false;
      }
    );
  }

  // Parent Quick Actions Methods
  resetParentPassword(e, parent) {
    e.stopPropagation();
    this.loading = true;
    const body = { national_id: parent?.national_id };
    this.staffService.resetStaffPassword(body).pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.showSuccessPasswordResetModal = true;
        this.loading = false;
      },
      error => {
        this.errorMsgService.setMessage(error?.error?.message);
        this.showSuccessPasswordResetModal = false;
        this.loading = false;
      }
    );
  }

  closePasswordResetModal() {
    this.showSuccessPasswordResetModal = false;
  }

  regenerateParentQr(e, parent) {
    e.stopPropagation();
    this.qrControl.setRegenerateUserData(parent);
    $('#confirmModal').modal('show');
  }

  selectChanged(event) {
    let index = event.index;
    let row = event.data;
    let allRows = event.dataValues;
    let checked = event.checked;
    if (checked) { // checked
      if (index == "all") {
        // add the current page's rows without dropping rows selected on other pages / filters
        const alreadySelected = new Set(this.selectedCheckBoxes.map(selected => selected.id));
        this.selectedCheckBoxes = [...this.selectedCheckBoxes, ...allRows.filter(r => !alreadySelected.has(r.id))];
      } else if (!this.selectedCheckBoxes.some(selected => selected.id == row.id)) {
        this.selectedCheckBoxes.push(row);
      }
    } else { // unchecked
      if (index == "all") {
        // only deselect the rows currently shown; keep the rest of the selection
        const shownIds = new Set(allRows.map(r => r.id));
        this.selectedCheckBoxes = this.selectedCheckBoxes.filter(selected => !shownIds.has(selected.id));
      } else {
        this.selectedCheckBoxes = this.selectedCheckBoxes.filter(selected => selected.id != row.id);
      }
    }

    this.syncSelectionButtons();
  }

  private syncSelectionButtons() {
    const hasSelection = this.selectedCheckBoxes.length > 0;
    this.controlDeletion.toggleDeleteBtn(hasSelection);
    this.messageControl.toggleMessageBtn(hasSelection);
  }

  generateExcelFile() {

    switch (this.listType) {
      case "students":
        this.studentService.exportStudentsFile(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number).pipe(takeUntil(this.destroy$)).subscribe(res => {
          //console.log('(c)listing_(f)exportStudentsFile_(L)733' , res);
         })
        break;
      case "parents":
        this.parentService.exportParentsFile(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number).pipe(takeUntil(this.destroy$)).subscribe(res => {
          //console.log('(c)listing_(f)exportParentsFile_(L)738' , res);
         })
        break;

    }
    // this.listType == 'students' ? this.studentService.exportStudentsFile(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number).pipe(takeUntil(this.destroy$)).subscribe(res => { }) :
    //   this.parentService.exportParentsFile(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number).pipe(takeUntil(this.destroy$)).subscribe(res => { })


    // this.dashboardService.generateExcelFile(this.reportFilter).pipe(takeUntil(this.destroy$)).subscribe(res => {
    // })
  }

  printQr(event){
    console.log(event);
    this.qrControl.setQrRevampObj(event);
    $('#qrRevamp').modal("show");
    
  }

  approveAllRequests(){
    this.globalService.setApproveAllRequests('preparing');
    this.requestsService.approveAllEditRequests().pipe(takeUntil(this.destroy$)).subscribe(res=>{
      //console.log('(c)listing_(f)approveAllRequests_(L)761' , res);

    })
  }

  getRequestCardData(event){
    this.requestCardData = null;
    this.requestCardData = event;
  }

  getEarlyDismissalCardData(event){
    this.earlyDismissalRequestCardData = null;
    this.earlyDismissalRequestCardData = event;
  }

  openModal(modalType:string , mode:string , data:any): void {
    const modalConfig = this.modalService.createModalConfig(modalType , mode , data  );
    this.modalService.openModal(modalConfig, this.modalContainer);
  }
}